import React from 'react'
import { withRouter, Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { getTopBarConfig } from '../../selectors'
import MobileSearchToolbar from './SecondaryToolbars/MobileSearchToolbar'

const SecondayToolbar = ({
  toolbarComponentName,
  match,
  mobileSearchActive,
}) => {
  if (mobileSearchActive) {
    return <MobileSearchToolbar />
  }
  // Page \w no toolbar
  if (!toolbarComponentName) {
    return null
  }
  // Black magic!
  const ToolbarComponent = require(`./SecondaryToolbars/${toolbarComponentName}`)
    .default
  // inject the react-router match into toolbar component as pageMatch
  // to avoid collision \.-./ Far away from problemi
  return <ToolbarComponent pageMatch={match} />
}

const mapStateToProps = state => {
  const config = getTopBarConfig(state)
  return {
    toolbarComponentName: config.toolbar,
    match: config.match,
    mobileSearchActive: state.ui.mobileSearch,
  }
}
export default connect(mapStateToProps)(SecondayToolbar)



// WEBPACK FOOTER //
// ./src/common/TopBar/SecondayToolbar.js